import { client } from '@app/data/iron';
import { useMount } from 'react-use';

const useCookieRewrite = () => {
  useMount(() => {
    client.get('/api/cookieRewrite');
  });
};

export default useCookieRewrite;
